/**
 * Ofertas por talla en la grilla de cotizacion y pedido.
 *
 * La grilla agrupa por estilo-color, pero el precio es de cada talla: una
 * oferta puede aplicar solo a una talla (ej. 403751-BR-36). Cada linea guarda
 * su precio de venta (precioActual) y su precio de lista sin oferta
 * (precioLista); los totales ya se calculan por linea.
 */

const num = value => (value === null || value === undefined || value === '' ? null : Number(value))

/**
 * Oferta de una talla, para mostrar el precio de lista tachado y el ofertado.
 * null si la talla no tiene oferta o si no hay rebaja real.
 */
export function lineOffer(line) {
  if (!line || !line.isOffer) return null

  const lista = num(line.precioLista)
  const oferta = num(line.precioActual)

  if (lista === null || oferta === null || !(oferta < lista)) return null

  return { lista, oferta, ahorro: Number((lista - oferta).toFixed(2)) }
}

/**
 * Precio que se muestra en la columna "Precio unit" de la fila (estilo-color).
 * Con ofertas solo en algunas tallas, la fila muestra el precio de las tallas
 * SIN oferta y avisa cuantas tallas la tienen; cada talla ofertada muestra su
 * propio precio en su celda.
 */
export function rowPriceSummary(lines) {
  const todas = lines || []
  const ofertadas = todas.filter(l => lineOffer(l))
  const normal = todas.find(l => !lineOffer(l)) || todas[0] || {}

  return {
    precioActual: num(normal.precioActual) ?? 0,
    isCustomPrice: Boolean(normal.isCustomPrice),
    // La fila entera esta ofertada solo si todas sus tallas lo estan.
    isOffer: todas.length > 0 && ofertadas.length === todas.length,
    offerSizes: ofertadas.length,
  }
}

/**
 * Variante de la API (product-variant-with-prices) -> variante del catalogo de
 * la pantalla. Unico lugar del mapeo: antes estaba copiado en las cuatro
 * pantallas y dejaba fuera is_offer y precio_lista, asi que la grilla nunca
 * se enteraba de las ofertas por talla.
 */
export function catalogVariant(v) {
  return {
    id: v.id,
    sku: v.label,
    size: v.size || '',
    stock: v.stock || 0,
    precio: v.precio,
    base_price: v.base_price,
    is_custom_price: v.is_custom_price,
    is_offer: v.is_offer,
    precio_lista: v.precio_lista,
    // Servicios cuentan completos para el minimo de unidades (unitRuleStatus).
    categoria: v.categoria,
    descripcion: v.descripcion,
    presentacion: v.presentacion,
  }
}
